import { render } from "./change-password-modal.vue?vue&type=template&id=5086b8fc&ts=true"
import script from "./change-password-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./change-password-modal.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/main/webapp/app/account/change-password/change-password-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5086b8fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5086b8fc', __exports__)) {
    api.reload('5086b8fc', __exports__)
  }
  
  module.hot.accept("./change-password-modal.vue?vue&type=template&id=5086b8fc&ts=true", () => {
    api.rerender('5086b8fc', render)
  })

}


export default __exports__